import { render, staticRenderFns } from "./icon-item.vue?vue&type=template&id=1131c3e5&"
import script from "./icon-item.vue?vue&type=script&lang=js&"
export * from "./icon-item.vue?vue&type=script&lang=js&"
import style0 from "./icon-item.vue?vue&type=style&index=0&id=1131c3e5&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports